import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { apiRequest, muviUserId, openInNewWindow } from "../../utils/utils";

const LoginToAccount = (props) => {

  const { data } = props;

  console.log("LoginToAccount data", data);
  const [standard, setStandard] = useState(false);

  const standardChangeHandler = (evt) => {
    setStandard(evt.target.checked);
  };

  const loginSubmit = async (isStandard) => {
    let requestData = {
      product_key: data.product_key,
      user_uuid: data.user_uuid,
      // key: data && data.type,
      // server: data && data.server,
      muvi_userid: muviUserId().user_id,
      standard: isStandard,
      app_token: data.customer_id || "",
    };

    if (data.isMuvi5) {
      const {
        enterprise_api_gateway_url,
        apigateway_url,
        encrypted_password,
        email,
        store_id,
        customer_id
      } = data;
      
      const api_url =
        enterprise_api_gateway_url ||
        "https://cms.muvi.com";

      let url =
        api_url +
        "/login/storeLogin" +
        "?email=" +
        email +
        "&password=" +
        encrypted_password +
        "&studio_id=" +
        customer_id +
        "&muviEmployeeId=" +
        muviUserId().user_id;
      props.close();
      openInNewWindow(url);
    } else {
      const responseData = await apiRequest(
        `${process.env.REACT_APP_CRM}/muvi6/auto-login`,
        "POST",
        requestData
      );
      if (responseData.code === 200) {
        openInNewWindow(responseData.data);
        props.close();
      }
    }
  };
  return (
    <Modal show={props.show} onHide={props.close} centered>
      <Modal.Header>
        <Modal.Title>{props.data.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5 style={{ color: "rgb(87, 87, 87)" }}>{props.data.confirmText}</h5>
      </Modal.Body>
      <Modal.Footer>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>
            <input
              type="checkbox"
              name=""
              id=""
              onChange={standardChangeHandler}
            />{" "}
            Take me to staging account
          </span>
          <div>
            <Button
              type="button"
              variant="dark"
              className="btn-dark-btn"
              onClick={props.close}
            >
              Close
            </Button>
            <Button
              type="button"
              variant="primary"
              onClick={() => loginSubmit(standard)}
            >
              Submit
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default LoginToAccount;



// WEBPACK FOOTER //
// ./src/components/childcomponents/LoginToAccount.js